import { Component } from '@angular/core';

@Component({
  selector: 'app-header-corporates',
  templateUrl: './header-corporates.component.html',
  styleUrls: ['./header-corporates.component.css']
})
export class HeaderCorporatesComponent {

}
